import React, { useState } from 'react';
import { Info } from 'lucide-react';

export default function RadioQualifiedListenInfo({
  buttonClassName = 'jg-radio-dock-info-btn',
  popoverClassName = 'jg-radio-dock-play-info-popover',
  tooltipId = 'jg-radio-dock-play-count-info',
}) {
  const [open, setOpen] = useState(false);

  return (
    <span
      className="jg-radio-dock-info-wrap"
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={buttonClassName}
        aria-label="How qualified plays count"
        aria-expanded={open}
        aria-describedby={open ? tooltipId : undefined}
        onClick={() => setOpen((current) => !current)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onMouseEnter={() => setOpen(true)}
      >
        <Info aria-hidden="true" size={14} />
      </button>
      {open ? (
        <span id={tooltipId} className={popoverClassName} role="tooltip">
          <strong>How qualified plays count</strong>
          <span>
            A play counts after real time with the record: at least 30 seconds
            or 25%.
          </span>
          <span>
            Real repeat listens can count. Quick skips do not.
          </span>
          <span>
            JG also tracks unique daily listener activity separately to keep
            the numbers honest.
          </span>
          <span>Bumpers do not count.</span>
        </span>
      ) : null}
    </span>
  );
}
